<template>
  <div class="filter-local-tree">
    <nestable-tree :value="value"
                   :options="locals"
                   :normalizer="normalizer"
                   :no-options-text="$t('message.automation.message.noSpotRegistered')"
                   :placeholder="$t('message.generics.message.spots')"
                   @input="emitInput">
      <div slot="option-label"
           slot-scope="{ node }">
        <filter-local-tree-item :node="node" />
      </div>
    </nestable-tree>
  </div>
</template>

<script>
import FilterLocalTreeItem from "@/components/filters/local/tree/item/FilterLocalTreeItem";
import NestableTree from "@/components/generic/nestable/tree/NestableTree";

export default {
  components: {
    NestableTree,
    FilterLocalTreeItem,
  },

  data() {
    return {
      localsLoaded: false,
      locals: [],
      normalizer(node) {
        return {
          id: node.localTreeId,
          label: node.name,
          children: node.children,
        };
      },
    };
  },

  props: {
    value: {
      type: Array,
      default() {
        return [];
      },
    },
    step: {
      type: Object,
    },
    automationId: {
      type: String,
    },
  },

  watch: {},

  async created() {
    await this.loadLocals();
  },

  methods: {
    emitInput(val) {
      this.$emit("input", val);
    },
    setNodes(node) {
      const newVal = [...this.value];

      const localIndex = newVal.findIndex((selectedNodeId) => {
        return selectedNodeId === node.localTreeId;
      });

      if (localIndex > -1) {
        newVal.splice(localIndex, 1);
      } else {
        newVal.push(node.localTreeId);
      }

      this.emitInput(newVal);
    },
    async loadLocals() {
      try {
        this.localsLoaded = false;

        const list = await this.$api.marketing.automation.flow.getLocalTree({
          automationId: this.automationId,
          stepId: this.step && this.step.id,
        });

        this.locals = [...list];

        this.removeLastChildren(this.locals);

        this.localsLoaded = true;
      } catch (error) {
        console.log(error);
      }
    },
    removeLastChildren(locals) {
      for (const local of locals) {
        if (local.children.length > 0) {
          this.removeLastChildren(local.children);
        } else {
          local.children = undefined;
        }
      }

      return locals;
    },
  },

  beforeDestroy() {},

  mixins: [],

  mounted() {},
};
</script>

<style lang="scss" scoped>
</style>
